export default __webpack_public_path__ + "static/media/wooden-rope.660bb068.svg";